import { render, staticRenderFns } from "./bar-progress.vue?vue&type=template&id=4772ce14&scoped=true&"
import script from "./bar-progress.vue?vue&type=script&lang=js&"
export * from "./bar-progress.vue?vue&type=script&lang=js&"
import style0 from "./bar-progress.vue?vue&type=style&index=0&id=4772ce14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772ce14",
  null
  
)

export default component.exports